import React, { useState } from 'react';
import axios from 'axios';

export default function ListItem({
  item,
  editUTMs,
  archiveStatus,
  unarchiveItem,
  archiveItem
}) {
  const { date, user, organization, group_name, utms, batch_id } = item;
  const [currentArchiveState, setcurrentArchiveState] = useState(archiveStatus);

  const archiveToggle = (batch_id, currentArchiveState) => {
    if (currentArchiveState) {
      axios
        .post(`/wp-admin/admin-ajax.php?action=unarchive_utm_batch`, {
          batch_id
        })
        .then(() => {
          setcurrentArchiveState(false);
          unarchiveItem(batch_id);
          console.log('item unarchived');
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .post(`/wp-admin/admin-ajax.php?action=archive_utm_batch`, {
          batch_id
        })
        .then(() => {
          setcurrentArchiveState(true);
          archiveItem(batch_id);
          console.log('item archived');
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div className={'grid utm__list-items'}>
      <div
        className="grid__col-lg-3 u--display-flex u--align-items-center"
        style={{ paddingRight: '0' }}
      >
        {date}
      </div>
      <div className="grid__col-lg-2 u--display-flex u--align-items-center">
        {user}
      </div>
      <div className="grid__col-lg-1 u--display-flex u--align-items-center">
        {organization}
      </div>
      <div className="grid__col-lg-3 u--display-flex u--align-items-center">
        {group_name}
      </div>
      <div className="grid__col-lg-1 u--display-flex u--align-items-center">
        {utms}
      </div>
      <div className="grid__col-lg-1 u--display-flex u--align-items-center">
        <button
          className="utm__edit-btn btn "
          onClick={() => {
            editUTMs(item);
          }}
        >
          Edit
        </button>
      </div>
      <div
        className="grid__col-lg-1 u--display-flex u--align-items-center"
        style={{ padding: '0' }}
      >
        <button
          className="utm__archive-btn btn"
          onClick={() => {
            archiveToggle(batch_id, currentArchiveState);
          }}
        >
          {currentArchiveState ? 'Unarchive' : 'Archive'}
        </button>
      </div>
    </div>
  );
}
